<template>
   <div style="padding: 10px 20px;">
      <div style="padding-bottom: 10px;">
         <el-button type="primary" @click="getButtonList">刷新页面</el-button>
      </div>
      <div style="display:flex;align-items: center;flex-wrap: wrap;">
         <el-card class="box" v-for="(item, index) in list" :key="index" shadow="hover" >
            <div class="image" @click.stop="addClick(item)">
               <img style="width: 25px;height: 25px;" src="@/assets/sh.png" alt="">
            </div>
            <div class="content" @click.stop="addClick(item)">
               <p class="wfdName">{{ item.wfdName }}</p>
               <p class="remark">备注：{{ item.remark }}</p>
            </div>
         </el-card>
      </div>
      <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
         <flowInstanceApplyAction v-if="showStatus" :actionData="actionData" @drawerCancel="drawerCancel"></flowInstanceApplyAction>
      </el-drawer>
   </div>
</template>

<script>
import flowInstanceApplyAction from "@/components/flowInstanceApplyAction.vue";
export default {
   name: "flowInstanceApply",
   components: { flowInstanceApplyAction },
   data() {
      return {
         list: [],
         buttonList: [],
         showStatus: false,
         actionData: {},
      }
   },
   created() {
      this.getButtonList()
   },
   methods: {
      drawerCancel(val) {
         this.showStatus = false
         if (val) {
         }
      },
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
         if (this.buttonList.length > 0) {
            this.queryList()
         }
      },
      async queryList() {
         let responseData = await this.$http.queryDeinition({ wfdName: "" });
         if (responseData && responseData.status == 200) {
            this.list = []
            this.buttonList.forEach(item => {
               var arr = responseData.result.filter(val => val.wfdId == item.jurId)
               if (arr.length > 0) {
                  this.list.push(...arr)
               }
            })
            console.log(this.list);

         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      addClick(item) {
         this.actionData = item
         this.actionData.cate = 0
         this.showStatus = true
      },
   }
}
</script>

<style scoped>
.box {
   padding: 10px;
   min-width: 300px;
   width: calc((100vw - 140px) / 5);
   height: 70px;
   display: flex;
   align-items: center;
   cursor: pointer;
   border-radius: 10px;
   box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
   margin-bottom: 20px;
   margin-right: 20px;
}

.image {
   width: 50px;
   height: 50px;
   background-color: #f7b51c;
   border-radius: 10px;
   padding: 12.5px;
}

.content {
   padding-left: 10px;
   height: 50px;
   width: 100%;
}

.wfdName {
   font-size: 14px;
   color: #333;
   margin-bottom: 5px;
   width: 100%;
}

.remark {
   color: #8b8b8b;
   font-size: 12px;
   width: 100%;
}

::v-deep .el-card__body {
   padding: 0;
   height: 50px;
   display: flex;
   align-items: center;
   width: 100%;
}

::v-deep .el-card.is-hover-shadow:hover {
   box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
}
</style>